const LICENSE_CODE_HEADER = 'Código'

const cleanCell = cell => cell.trim().replace(/^"(.*)"$/, '$1').trim()

const detectDelimiter = headerLine => {
    if (headerLine.includes('\t')) return '\t'
    const semicolons = (headerLine.match(/;/g) || []).length
    const commas = (headerLine.match(/,/g) || []).length
    if (semicolons > commas) return ';'
    return ','
}

export const parseLicenseCodesCsv = text => {
    const lines = (text || '')
        .split(/\r\n|\r|\n/)
        .map(line => line.trim())
        .filter(line => line.length > 0)

    if (lines.length === 0) {
        return { hasCodeColumn: false, codes: [] }
    }

    const delimiter = detectDelimiter(lines[0])
    const headers = lines[0].split(delimiter).map(cleanCell)
    const codeColumnIndex = headers.indexOf(LICENSE_CODE_HEADER)

    if (codeColumnIndex === -1) {
        return { hasCodeColumn: false, codes: [] }
    }

    const codes = lines
        .slice(1)
        .map(line => cleanCell(line.split(delimiter)[codeColumnIndex] || ''))
        .filter(code => code.length > 0)

    return { hasCodeColumn: true, codes }
}

export default LICENSE_CODE_HEADER
